import styled from 'styled-components';

export const MapContainer = styled('div')`
  aspect-ratio: 5/3;
`;

export const FlagContainer = styled('div')`
  width: ${({ theme }) => theme.x16spacePx}px;
  height: ${({ theme }) => theme.x10spacePx + 5}px;
`;
